export default __webpack_public_path__ + "lib/button-border.cc35cb241b509e3e76df51781ebcf9b8.svg";